const homecontent = {
  home: {
    bulletpointsOne: [
      "Restore your pain free mobility",
      "Improve overall movement quality",
      "Individually tailored corrective exercises",
      // "Learn active recovery strategies",
    ],
    bulletpointsTwo: [
      "Reduce pain, stiffness, and muscle tension",
      "Targeted tissue work to reduce soreness",
      "Improve relaxation with therapeutic massage",
    ],
    bulletpointsThree: [
      "Assess and fine tune movement patterns",
      "Adapt a comprehensive exercise program",
      "Improve strength, endurance, and capacity",
    ],
  },
};

export default homecontent;
